module.exports = __webpack_public_path__ + "static/media/img6.7f3f64f3.png";